import { QueryClient } from '@tanstack/react-query'
import { message } from 'antd'
import i18next from 'i18next'
import { applyInvalidation, findInvalidation } from '../../shared/queries/cacheInvalidationGraph'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      experimental_prefetchInRender: true,
      // globally default to 1 minutes
      staleTime: 1000 * 60 * 1
    },
    mutations: {
      onError: () => {
        message.error(i18next.t('mutation:error:message:default'))
      }
    }
  }
})

// 202 Accepted (see backendRequestWithStatus): the backend recalculates in the background
// and sends a Novu event when done, so dependent queries are not ready to be refetched yet.
const isAccepted = (data: unknown) => (data as { status?: number } | undefined)?.status === 202

// Invalidate dependent queries (see cacheInvalidationGraph) once per successful mutation.
// Active queries, reports included, refetch immediately so the user sees their own change.
queryClient.getMutationCache().subscribe(event => {
  if (event.type !== 'updated' || event.action.type !== 'success') return
  const { mutationKey } = event.mutation.options
  const invalidation = findInvalidation(mutationKey)
  if (!invalidation) return

  if (isAccepted(event.action.data)) {
    // Only the mutated entity itself; the Novu invalidation handles the rest
    queryClient.invalidateQueries({ queryKey: mutationKey })
    return
  }

  applyInvalidation(queryClient, invalidation, { refetchReports: true })
})
